import type { IssueTypeField } from '../getIssueTypeFields';
import { JiraFieldMappersKeys, type JiraFieldMapper } from './types';
import { findJiraFieldByKey } from './findJiraFieldByKey';

export const maxShortTextLength = 255;

export class ShortTextMapper implements JiraFieldMapper {
  id = JiraFieldMappersKeys.ShortText;
  isEnum = false;

  canMapThisField(jiraSchema: IssueTypeField[], fieldKey: string): boolean {
    const targetField = findJiraFieldByKey(jiraSchema, fieldKey);

    if (!targetField) {
      return false;
    }

    const { type, custom } = targetField.schema;
    const isCustomType = !!custom;
    const isString = type === 'string';

    return isCustomType
      ? isString &&
          custom ===
            'com.atlassian.jira.plugin.system.customfieldtypes:textfield'
      : isString;
  }

  formatFieldValue(
    jiraSchema: IssueTypeField[],
    fieldKey: string,
    sourceValue: unknown
  ): string | undefined {
    const fieldName = findJiraFieldByKey(jiraSchema, fieldKey)?.name;

    const formattedValue =
      typeof sourceValue === 'object'
        ? JSON.stringify(sourceValue)
        : String(sourceValue).replaceAll('\n', ' ');

    if (formattedValue.length > maxShortTextLength) {
      throw new Error(
        `Can not map to '${fieldName}': mapped value length more than ${maxShortTextLength}`
      );
    }

    return formattedValue;
  }
}
